<template>
    <div class="globalPopup">
        <div class="popupbg"></div>
        <div class="relative z-40 m-auto" style="width: 600px">
            <vs-card class="shadow-none header m-none">
                <vs-row>
                    <vs-col vs-w="11">
                        <h3 class="header__title">Header</h3>
                    </vs-col>
                    <vs-col vs-w="1">
                        <div class="relative">
                            <vs-button class="closeBtn" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-card>
            <vs-card class="shadow-none content m-none" :style="{'max-height': height + 'px'}">
                <slot></slot>
            </vs-card>
            <vs-card class="shadow-none footer m-none">
                <div>Footer</div>
                <div>Footer</div>
                <div>Footer</div>
                <div>Footer</div>
            </vs-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            heightNum: 0
        }
    },

    computed: {
        height() {
            return this.heightNum
        }
    },

    methods: {
        getHeight() {
            const header = document.querySelector('.globalPopup .header').clientHeight
            const footer = document.querySelector('.globalPopup .footer').clientHeight
            return ~~document.body.clientHeight - header - footer - 40
        }
    },

    mounted() {
        this.heightNum = this.getHeight()
    }
}
</script>

<style lang="scss">
.globalPopup {
    z-index: 999999999;
    position: fixed;
    width: 100%;
    left: 0;
    padding: 20px;
    top: 0;
    height: 100%;

    .m-none {
        margin-bottom: 0;
        .vs-card--content {
            margin-bottom: 0;
        }
    }

    .closeBtn {
        position: absolute;
        top: -15px;
        right: -15px;
    }

    .header {
        background-color: #f2f2f2;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        &__title {
            font-size: 1.2rem;
        }
    }

    .content {
        border-radius: 0;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 0;
        }
    }

    .footer {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .popupbg {
        left: 0;
        width: 100%;
        background: rgba(0,0,0,.4);
        position: absolute;
        top: 0;
        height: 100%;
        z-index: 10;
        opacity: 1;
    }
}
</style>
